import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { Subject, takeUntil } from 'rxjs';
import { DRAWER_IDS } from '../../../../../../core/constants/drawer-ids.constant';
import { DrawerService } from '../../../../../../core/services/drawer.service';
import { AuditType } from '../../../../../bip-template/bip-template.enums';
import { DataLogDetailParams, DataLogs } from '../data-log.interface';
import { UserDatePipe } from '../../../../../../shared/pipes/user-date.pipe';
import { InsightsDataService } from '../../../insights-data/insights-data.service';

@Component({
  selector: 'app-data-log-detail',
  standalone: true,
  imports: [SvgIconComponent, NzDividerModule, CommonModule, UserDatePipe],
  templateUrl: './data-log-detail.component.html',
})
export class DataLogDetailComponent implements OnDestroy {
  private readonly destroy$ = new Subject<void>();
  logDetail: DataLogs | null = null;
  AuditTypeEnums = AuditType;
  constructor(
    private readonly drawerService: DrawerService,
    private readonly insightsDataService: InsightsDataService
  ) {
    this.setupDrawerParams();
  }

  private setupDrawerParams(): void {
    this.drawerService
      .getParams<DataLogDetailParams>(DRAWER_IDS.DATA_LOG_DETAIL)
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        if (params) {
          this.logDetail = params.selectedLog;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  formatTimeSlot(timeSlot: string | null | undefined): string {
    if (!timeSlot) {
      return '-';
    }

    const [startTime = '', endTime = ''] = timeSlot
      .split('-')
      .map(value => value.trim());

    if (!startTime && !endTime) {
      return '-';
    }

    const formattedStart = startTime
      ? this.insightsDataService.formatTimeTextTo12Hour(startTime)
      : 'N/A';
    const formattedEnd = endTime
      ? this.insightsDataService.formatTimeTextTo12Hour(endTime)
      : 'N/A';

    return `${formattedStart} - ${formattedEnd}`;
  }
}
